export const TEXT_FIELD_DATA_GRABS = {
    textFieldWrapperDataGrab: 'product-customizations-text-field',
    labelDataGrab: 'product-customizations-text-field-label',
    textareaDataGrab: 'product-customizations-text-field-textarea',
    textareaPlaceholderDataGrab:
        'product-customizations-text-field-placeholder',
    counterDataGrab: 'product-customizations-text-field-counter',
    checkboxesContainerDataGrab: 'product-customizations-checkboxes-container',
    checkboxLabelDataGrab: 'product-customizations-checkbox-label',
    checkboxDataGrab: 'product-customizations-checkbox',
    checkboxCheckedDataGrab: 'product-customizations-checkbox-checked',
};

export const MAX_TEXT_FIELD_LENGTH = 320;
